<template>
  <div>
      <MasterHeader
        v-bind:classHeader="'registration'"
        v-bind:classGrid="'wp1200'"/>
    <section>
      <div class="wp800">
        <div class="onBoardRegistrationTwo">
          <div class="flex">
            <div class="col1_2">
              <img src="@/assets/images/superman.png" />
            </div>
            <div class="col1_2 text">
              <h2>
                <span>
                  {{ $t("registration.title") }}
                  <br />
                </span>{{ $t("registration.title2") }}
              </h2>
              <hr class="lightBlue" />
              <p>
                {{ $t("registration.text") }}
              </p>
              <a
                class="join smallFont hoverEffect"
                v-on:click="startOnBoarding"
                ref="joinButton1"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
              >
                <label>{{ $t("registration.link") }}</label>
                <span
                  class="effect"
                  ref="effectButton1"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
                ></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterHeader from '../partials/MasterHeader';
import { formUtilsMouseHoverEffect} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      onboardingUrl: "",
      topX: 1,
      leftX: 1,
      notCompleted: true,
    };
  },
  components: {
    MasterHeader
  },
  computed:{
 
      status() {
        return this.$store.getters["user/status"];
      },
      onboardingProjects() {
        return this.$store.getters["user/onboardingProjects"];
      },
      user() {
      return this.$store.getters['user/user'];
    },
  },
  mounted() {
    this.backOrRedirect();
    this.loadTransactions();
  },
  methods: {
    formUtilsMouseHoverEffect,

    loadTransactions() {
        return this.$store.dispatch("user/userinfo");
    },
    backOrRedirect () {
      if(this.status.status === 1){
        this.$router.push({ name: "dashboard"});
      }
    },
    startOnBoarding() {
      if(this.status.status === 2){
        this.onboardingUrl = this.onboardingProjects[0].url;
        window.location.href = this.onboardingUrl;
      }
    },
  },
};
</script>
<style>
</style>